import { Tag } from 'foundations-components/transitional/components/Tag';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const TagsContainer = styled.div.withConfig({
  displayName: "QuickFiltersTags__TagsContainer",
  componentId: "sc-1tvgdk4-0"
})(["display:flex;flex-wrap:wrap;gap:8px 12px;"]);
const QuickFiltersTags = props => {
  const {
    tags,
    onTagClose
  } = props;
  return /*#__PURE__*/_jsx(TagsContainer, {
    children: tags.map(tag => /*#__PURE__*/_jsx(Tag, {
      use: "default",
      onCloseClick: () => onTagClose(tag.value),
      closeable: true,
      marginInlineStart: "0",
      children: tag.label
    }, tag.value))
  });
};
export default QuickFiltersTags;